import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";
import { useNavigate } from "react-router";

interface IModelData {
  name: string;
  fields: any;
  relationships: any[];
}

interface ISingleItemData {
  name: string;
  fields: any;
  data: any;
}

interface IUserData {
  id: number;
  username: string;
  user_role: string;
}

interface IHostData {
  frontendUrl: string;
  frontendPort: number;
  backendUrl: string;
  backendPort: number;
  awsBucket: string;
  awsRegion: string;
}

const defaultModelData: IModelData[] = [];

const modelDataAtom = atom<IModelData[]>(defaultModelData);
const loginStatusAtom = atom<boolean>(false);
const userAtom = atom<IUserData | null>(null);
const hostDataAtom = atom<IHostData>({
  frontendUrl: "localhost",
  frontendPort: 5000,
  backendUrl: "localhost",
  backendPort: 8080,

  awsBucket: "lightwell-nextsense-site-syd",
  awsRegion: "ap-southeast-2",
});
const uploadListAtom = atom<string[]>([]);

// Check model against model data - if not valid, redirect to error page
const useValidateModel = (stringToValidate: string) => {
  const navigate = useNavigate();
  const data = useAtomValue(modelDataAtom);
  if (
    !data.find((model) => {
      return model.name === stringToValidate;
    })
  )
    navigate("/m/error");
};

// Add uploading atom
/**
 * Utility for adding fieldId to upload list
 * @returns [addToList(fieldId), removeFromList(fieldId)]
 */
const useModifyUploadList = (fieldId: string): [() => void, () => void] => {
  const [uploadList, setUploadList] = useAtom(uploadListAtom);
  const addToList = () => setUploadList([...uploadList, fieldId]);
  const removeFromList = () => {
    const newList = uploadList.filter((field) => field !== fieldId);
    setUploadList(newList);
  };
  return [addToList, removeFromList];
};

export {
  loginStatusAtom,
  modelDataAtom,
  hostDataAtom,
  useValidateModel,
  userAtom,
  uploadListAtom,
  useModifyUploadList,
};
export type { IModelData };
